import { render, staticRenderFns } from "./UserAccess.vue?vue&type=template&id=54942eba&scoped=true"
import script from "./UserAccess.vue?vue&type=script&lang=js"
export * from "./UserAccess.vue?vue&type=script&lang=js"
import style0 from "./UserAccess.vue?vue&type=style&index=0&id=54942eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54942eba",
  null
  
)

export default component.exports